// extracted by mini-css-extract-plugin
module.exports = {"inputRadio":"InputRadio_inputRadio__j6cM7","childText":"InputRadio_childText__ZRKrD","manualChecked":"InputRadio_manualChecked__YdMY9"};